
export function alert(msg){
    if(process.env.NODE_ENV==='development'){
        window.alert(msg)
    }
}

export function log(msg){
    if(process.env.NODE_ENV==='development'){
        console.log(msg)
    }
}